import React, { useEffect, useRef, useState } from "react";
import { withStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import constants from "utils/constants";
import { apiGetUserWalmartAuthorizeStatus, apiUserDisconnectSpApi, apiWalmartAuthorize } from "api/user";
import { connectAutoDispatch } from "redux/reduxConnect";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import { Space, Spin } from "antd";

const styles = theme => ({
  main: {
    display: "block", // Fix IE 11 issue.
    width: "100%",
    [theme.breakpoints.up(700)]: {
      width: 640,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paperHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}`
  },
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(3)}`
  },
  status: {
    fontSize: 16,
    "& > span": {
      textTransform: "capitalize"
    }
  },
  authorizeBtn: {
    marginTop: `${theme.spacing(2)}`,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& button": {
      minWidth: 100,
      marginTop: 10
    }
  }
});

const WalmartProccessAuthorize = props => {
  const { classes } = props;
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const trick = localStorage.getItem("walmart_success");

  useEffect(() => {
    const x = new URLSearchParams(window.location.search);
    proccessAuthorize();
  }, []);

  const proccessAuthorize = async () => {
    if (trick === "true") {
      setAuthorized(true);
      localStorage.setItem('walmart_success', 'false');
      window.location.href = `${window.location.origin}/user/walmart-integration`;
    }
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%", display: "flex", marginTop: "20px", alignItems: "center" }}>
      <Spin size="large" style={{ marginTop: "20px" }} />
    </Space>
  );
};

export default withStyles(styles)(
  connectAutoDispatch(state => ({ userInfo: state.userState.userInfo }), {})(WalmartProccessAuthorize)
);
